import { render, staticRenderFns } from "./elementForm.vue?vue&type=template&id=51b3bbe2&scoped=true&"
import script from "./elementForm.vue?vue&type=script&lang=js&"
export * from "./elementForm.vue?vue&type=script&lang=js&"
import style0 from "./elementForm.vue?vue&type=style&index=0&id=51b3bbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3bbe2",
  null
  
)

export default component.exports